import React, { useEffect, useState, useRef, useMemo } from 'react';
import Api from "../Auth/Api";
import ReconnectingWebSocket from 'reconnecting-websocket';
import { Modal, Toast } from 'react-bootstrap';
import { decodeJWT, obterPrimeiraUltimaLetra } from '../Components/jwtUtils';
import Select from 'react-select';
import { customStyles } from '../utils/selectStyles';

function Chat() {

    const token = JSON.parse(localStorage.getItem("user_token"));
    const nivel = decodeJWT(token).nivel;
    const messagesEndRef = useRef(null);

    const [conversations, setConversations] = useState([]);
    const [currentConversation, setCurrentConversation] = useState(null);
    const [messageText, setMessageText] = useState(""); // Estado para gerenciar o valor do input de mensagem
    const [ws, setWs] = useState(null);
    const [showModalAddChat, setShowModalAddChat] = useState(false);
    const [dataUsuariosChat, setDataUsuariosChat] = useState([]);
    const [inputValues, setInputValues] = useState({});
    const [searchTerm, setSearchTerm] = useState('');
    const [currentChatId, setCurrentChatId] = useState(null);
    const [toast, setToast] = useState({})
    const [showToast, setShowToast] = useState(false)
    const [selectedCourse, setSelectedCourse] = useState(null);
    const [filteredConversations, setFilteredConversations] = useState([]);
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const [conversationSearch, setConversationSearch] = useState('');


    // listar cursos
    const [dataCursos, setDataCursos] = useState([]);
    useEffect(() => {
        async function fetchData() {
            try {
                const response = await Api.get(`api/listar-cursos`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setDataCursos(response.data);
            } catch (error) {
                console.error(error);
            }
        }
        fetchData();
    }, [token]);


    // Obter os novos usuarios da conversa
    useEffect(() => {
        async function fetchData() {
            try {
                const response = await Api.get(`api/listar-usuarios-chat`, { headers: { Authorization: `Bearer ${token}` } });
                setDataUsuariosChat(response.data);
            } catch (error) {
                console.error(error.response.data.message)
            }
        }
        fetchData();
    }, [token, currentChatId]);


    const handleCourseChange = (selectedOption) => {
        setSelectedCourse(selectedOption);
    };

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };

    // Filtrar os novos usuarios da tabela 
    const filteredUsuariosChat = dataUsuariosChat.filter(user => {
        // Filtro pelo nome do usuário
        const isNameMatch = user.nome_completo.toLowerCase().includes(searchTerm.toLowerCase());

        // Se não houver curso selecionado, retorne apenas o resultado do filtro pelo nome
        if (!selectedCourse) return isNameMatch;

        // Converta a string 'permissao_cursos' em um array e verifique se contém o ID do curso selecionado.
        const userCourses = JSON.parse(user.permissao_cursos || "[]");
        const isCourseMatch = userCourses.includes(selectedCourse.value);

        // Retorne verdadeiro se ambos, o nome e o curso, corresponderem
        return isNameMatch && isCourseMatch;
    });

    // Mudar o valor do input da mensagem de iniciar um chat
    const handleInputChange = (e, userId) => {
        setInputValues(prevState => ({
            ...prevState,
            [userId]: e.target.value
        }));
    }


    const initiateChatWith = async (id, token, message) => {

        const data = {
            id: id,
            message: message
        }

        try {
            const response = await Api.post(`api/iniciar-chat/${id}`, data, { headers: { Authorization: `Bearer ${token}` } });
            if (response.data && response.data.idConversa) {
                setCurrentChatId(response.data.idConversa);
            }
        } catch (error) {
            console.error(error.response.data.message);
            setToast({ header: 'Ops!', body: error.response.data.message, type: 'toast-error' })
            setShowToast(true)
        }
    }

    useEffect(() => {
        if (currentChatId) {
            handleConversationClick(currentChatId);
            setShowModalAddChat(false);
        }
        // eslint-disable-next-line
    }, [currentChatId]);

    // Conectar ao WebSocket
    useEffect(() => {

        const rws = new ReconnectingWebSocket(process.env.REACT_APP_SOCKET);

        rws.addEventListener('open', () => {
            // console.log('Conectado ao WebSocket');
        });

        rws.addEventListener('message', (event) => {
            const message = JSON.parse(event.data);
            // Atualize a conversa com a nova mensagem
            if (currentChatId) {
                setCurrentConversation(prevState => {
                    return {
                        ...prevState,
                        messages: [...prevState.messages, message]
                    };
                });
            }
        });

        rws.addEventListener('close', () => {
            // console.log('Desconectado do WebSocket');
        });

        rws.addEventListener('error', (error) => {
            // console.error('Erro no WebSocket:', error);
        });

        // Define o WebSocket no estado
        setWs(rws);

        return () => {
            rws.close();
        };


    }, [currentChatId]);

    // Obter as conversas 
    useEffect(() => {
        async function fetchData() {
            try {
                const response = await Api.get(`api/conversas`, { headers: { Authorization: `Bearer ${token}` } });
                setConversations(response.data);
            } catch (error) {
                console.error(error.response.data.message)
            }
        }
        fetchData();
    }, [token, currentChatId]);

    // Filtrar as conversas pelo select do cursos
    useEffect(() => {

        const filtered = conversations.filter(conversation => {
            if (!selectedCourse) return true; // Se nenhum curso estiver selecionado, mostre todos os usuários.

            // Converta a string 'permissao_cursos' em um array e verifique se contém o ID do curso selecionado.
            const isCourseMatch = JSON.parse(conversation.permissao_cursos || "[]"); // O "[]" padrão é usado para evitar erros se for nulo ou indefinido.
            return isCourseMatch.includes(selectedCourse.value);
        });


        setFilteredConversations(filtered);
    }, [conversations, selectedCourse]);

    // Função para formatar timestamp relativo
    const formatMessageTime = (timestamp) => {
        if (!timestamp) return '';
        const date = new Date(timestamp);
        const now = new Date();
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        const messageDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
        const yesterday = new Date(today);
        yesterday.setDate(yesterday.getDate() - 1);

        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');

        if (messageDate.getTime() === today.getTime()) {
            return `${hours}:${minutes}`;
        } else if (messageDate.getTime() === yesterday.getTime()) {
            return `Ontem ${hours}:${minutes}`;
        } else {
            const day = date.getDate().toString().padStart(2, '0');
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            return `${day}/${month} ${hours}:${minutes}`;
        }
    };

    // Função para agrupar mensagens consecutivas
    const groupMessages = (messages) => {
        if (!messages || messages.length === 0) return [];
        
        const grouped = [];
        let currentGroup = null;

        messages.forEach((message, index) => {
            const prevMessage = index > 0 ? messages[index - 1] : null;
            const isSameSender = prevMessage && prevMessage.type === message.type;
            const timeDiff = prevMessage 
                ? new Date(message.timestamp) - new Date(prevMessage.timestamp)
                : Infinity;
            const isWithinTimeWindow = timeDiff < 300000; // 5 minutos

            if (isSameSender && isWithinTimeWindow && currentGroup) {
                currentGroup.messages.push(message);
            } else {
                if (currentGroup) {
                    grouped.push(currentGroup);
                }
                currentGroup = {
                    type: message.type,
                    messages: [message]
                };
            }
        });

        if (currentGroup) {
            grouped.push(currentGroup);
        }

        return grouped;
    };


    // Seleciona a conversa e exibe na tela
    const handleConversationClick = async (conversationId) => {
        try {
            const response = await Api.get(`api/conversas/${conversationId}`, { headers: { Authorization: `Bearer ${token}` } });
            // Se a conversa é nova e não tem mensagens, definimos um formato padrão.
            if (!response.data.id) {
                setCurrentConversation({
                    id: "",
                    nome_completo: "",
                    messages: []
                });
            } else {
                setCurrentConversation(response.data);
            }
            // Fechar sidebar em mobile ao selecionar conversa
            setSidebarOpen(false);
        } catch (error) {
            console.error(error.response.data.message);
        }
    };

    // Voltar para a lista de conversas
    const handleBackClick = () => {
        setCurrentConversation(null);
        // Abrir sidebar ao voltar
        setSidebarOpen(true);
    };

    // Handler para fechar sidebar
    const handleCloseSidebar = () => {
        setSidebarOpen(false);
    };

    // Toggle sidebar no mobile
    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    // Enviar a mensagem
    const sendMessage = async () => {
        try {
            const data = {
                idConversa: currentConversation.id,
                text: messageText
            };
            await Api.post('/api/enviar-mensagem', data, { headers: { Authorization: `Bearer ${token}` } });
            setMessageText(""); // Limpar o campo de input após enviar a mensagem
            handleConversationClick(currentConversation.id); // Atualizar a conversa após enviar a mensagem
            ws.send(JSON.stringify(data));
        } catch (error) {
            // console.error(error.response.data.message);
        }
    };

    // Agrupar mensagens
    const groupedMessages = useMemo(() => {
        return currentConversation ? groupMessages(currentConversation.messages || []) : [];
    }, [currentConversation]);

    // Rolar a lista de mensagens para a mais recente
    useEffect(() => {
        if (messagesEndRef.current) {
            setTimeout(() => {
                messagesEndRef.current.scrollTop = messagesEndRef.current.scrollHeight;
            }, 100);
        }
    }, [currentConversation, groupedMessages]);

    // Filtrar conversas por busca
    const filteredConversationsBySearch = filteredConversations.filter(conv => {
        if (!conversationSearch) return true;
        return conv.nome_completo.toLowerCase().includes(conversationSearch.toLowerCase());
    });

    return (
        <>
            <Toast
                show={showToast}
                onClose={() => setShowToast(false)}
                delay={4000}
                autohide
                className={`position-fixed top-0 end-0 m-3 toast-icon ${toast.type || 'toast-error'}`}
                style={{ zIndex: 1060 }}
            >
                <Toast.Header>
                    <strong className="me-auto">{toast.header}</strong>
                </Toast.Header>
                <Toast.Body>{toast.body}</Toast.Body>
            </Toast>

            <div className="chat-container fade-in">
                {/* Sidebar de Conversas */}
                <div className={`chat-sidebar ${sidebarOpen ? 'open' : ''} ${!currentConversation ? 'd-md-block' : ''}`}>
                    <div className="chat-sidebar-header">
                        <div className="d-flex align-items-center justify-content-between mb-3">
                            <h5 className="mb-0 fw-semibold">Conversas</h5>
                            <div className="d-flex align-items-center gap-2">
                                <button
                                    className="btn btn-primary btn-sm"
                                    onClick={() => setShowModalAddChat(true)}
                                >
                                    <i className="bi bi-plus-lg"></i>
                                </button>
                                <button
                                    className="chat-close-sidebar-btn d-md-none"
                                    onClick={handleCloseSidebar}
                                    aria-label="Fechar"
                                    type="button"
                                >
                                    <i className="bi bi-x-lg"></i>
                                </button>
                            </div>
                        </div>
                        {nivel !== 'Aluno' && (
                            <div className="mb-3">
                                <Select
                                    options={dataCursos.map((value) => ({
                                        value: value.id,
                                        label: `${value.nome}`,
                                    }))}
                                    styles={customStyles}
                                    placeholder="Filtrar por curso"
                                    isSearchable
                                    isClearable
                                    onChange={handleCourseChange}
                                    value={selectedCourse}
                                    noOptionsMessage={() => "Nenhum curso encontrado."}
                                />
                            </div>
                        )}
                        <div className="chat-search">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Buscar conversas..."
                                value={conversationSearch}
                                onChange={(e) => setConversationSearch(e.target.value)}
                            />
                            <i className="bi bi-search"></i>
                        </div>
                    </div>
                    <div className="chat-conversations-list">
                        {filteredConversationsBySearch.length === 0 ? (
                            <div className="chat-empty-state">
                                <i className="bi bi-chat-dots"></i>
                                <p>Nenhuma conversa encontrada</p>
                            </div>
                        ) : (
                            filteredConversationsBySearch.map(conversation => (
                                <div
                                    key={conversation.id}
                                    className={`chat-conversation-item ${currentConversation?.id === conversation.id ? 'active' : ''}`}
                                    onClick={() => handleConversationClick(conversation.id)}
                                >
                                    <div className="chat-avatar">
                                        {obterPrimeiraUltimaLetra(conversation.nome_completo) || <i className="bi bi-person"></i>}
                                    </div>
                                    <div className="chat-conversation-info">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <span className="chat-conversation-name">{conversation.nome_completo}</span>
                                            {conversation.ultima_mensagem_timestamp && (
                                                <span className="chat-conversation-time">
                                                    {formatMessageTime(conversation.ultima_mensagem_timestamp)}
                                                </span>
                                            )}
                                        </div>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <span className="chat-conversation-preview">
                                                {conversation.ultima_mensagem 
                                                    ? (conversation.ultima_mensagem.length > 50 
                                                        ? conversation.ultima_mensagem.substring(0, 50) + '...' 
                                                        : conversation.ultima_mensagem)
                                                    : 'Nenhuma mensagem'}
                                            </span>
                                            {conversation.chat_aberto === 1 && (
                                                <span className="chat-unread-badge"></span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                </div>

                {/* Overlay para mobile */}
                {sidebarOpen && (
                    <div className="chat-sidebar-overlay d-md-none" onClick={handleCloseSidebar}></div>
                )}

                {/* Área de Mensagens */}
                {currentConversation ? (
                    <div className="chat-conversation-area">
                        <div className="chat-header">
                            <button className="chat-back-btn d-md-none" onClick={handleBackClick} aria-label="Voltar">
                                <i className="bi bi-arrow-left"></i>
                            </button>
                            <div className="chat-header-info">
                                <div className="chat-avatar chat-avatar-small">
                                    {obterPrimeiraUltimaLetra(currentConversation.nome_completo || currentConversation.name) || <i className="bi bi-person"></i>}
                                </div>
                                <div>
                                    <h6 className="mb-0">{currentConversation.nome_completo || currentConversation.name}</h6>
                                </div>
                            </div>
                        </div>
                        <div className="chat-messages-area" ref={messagesEndRef}>
                            {groupedMessages.length === 0 ? (
                                <div className="chat-empty-messages">
                                    <i className="bi bi-chat-left-text"></i>
                                    <p>Nenhuma mensagem ainda</p>
                                    <span>Envie uma mensagem para começar a conversa</span>
                                </div>
                            ) : (
                                groupedMessages.map((group, groupIndex) => (
                                    <div key={groupIndex} className={`message-group ${group.type === 'sent' ? 'message-group-sent' : 'message-group-received'}`}>
                                        {group.messages.map((message, msgIndex) => {
                                            const isLastInGroup = msgIndex === group.messages.length - 1;
                                            return (
                                                <div key={message.id || msgIndex} className={`message-bubble ${message.type === 'sent' ? 'message-sent' : 'message-received'}`}>
                                                    <div className="message-content">
                                                        {message.text}
                                                    </div>
                                                    {isLastInGroup && (
                                                        <div className="message-time">
                                                            {formatMessageTime(message.timestamp)}
                                                        </div>
                                                    )}
                                                </div>
                                            );
                                        })}
                                    </div>
                                ))
                            )}
                        </div>
                        <div className="chat-input-area">
                            <div className="chat-input-wrapper">
                                <input
                                    type="text"
                                    value={messageText}
                                    onChange={e => setMessageText(e.target.value)}
                                    onKeyDown={e => {
                                        if (e.key === 'Enter' && !e.shiftKey) {
                                            e.preventDefault();
                                            sendMessage();
                                        }
                                    }}
                                    className="chat-input"
                                    placeholder="Digite uma mensagem..."
                                />
                                <button
                                    className="chat-send-btn"
                                    onClick={sendMessage}
                                    disabled={!messageText.trim()}
                                >
                                    <i className="bi bi-send-fill"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="chat-welcome-screen">
                        <button className="chat-menu-btn-mobile d-md-none" onClick={toggleSidebar} aria-label="Abrir conversas">
                            <i className="bi bi-list" style={{ paddingTop: 12}}></i> Ver conversas
                        </button>
                        <i className="bi bi-chat-dots"></i>
                        <h4>Selecione uma conversa</h4>
                        <p>Escolha uma conversa da lista para começar a conversar</p>
                    </div>
                )}
            </div>

            <Modal size='lg' show={showModalAddChat} onHide={() => setShowModalAddChat(false)}>
                <Modal.Header closeButton>
                    <span className="fw-semibold fs-4 text-primary">Iniciar um novo chat</span>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="body">
                                <div className="input-group mb-3">
                                    <input type="text" className="form-control" placeholder="Buscar usuário..." onChange={handleSearchChange} />
                                    <span className="input-group-text"><i className="bi bi-search"></i></span>
                                </div>
                                <div className="scrollable-table" style={{ maxHeight: 400 }}>
                                    {filteredUsuariosChat.length === 0 ? (
                                        <div className="text-center p-4">
                                            <i className="bi bi-person-x fs-1 text-muted"></i>
                                            <p className="mt-2 text-muted">Nenhum usuário encontrado</p>
                                        </div>
                                    ) : (
                                        <div className="list-group">
                                            {filteredUsuariosChat.map(user => (
                                                <div key={user.id} className="list-group-item">
                                                    <div className="d-flex align-items-center gap-3">
                                                        <div className="chat-avatar chat-avatar-small">
                                                            {obterPrimeiraUltimaLetra(user.nome_completo) || <i className="bi bi-person"></i>}
                                                        </div>
                                                        <div className="flex-grow-1">
                                                            <div className="fw-semibold">{user.nome_completo}</div>
                                                            <small className="text-muted">{user.unidade}</small>
                                                        </div>
                                                        <div className="d-flex gap-2 align-items-center" style={{ minWidth: '300px' }}>
                                                            <input
                                                                className='form-control form-control-sm'
                                                                placeholder='Digite sua mensagem'
                                                                value={inputValues[user.id] || ''}
                                                                onChange={e => handleInputChange(e, user.id)}
                                                            />
                                                            <button
                                                                className="btn btn-primary btn-sm"
                                                                onClick={() => initiateChatWith(user.id, token, inputValues[user.id])}
                                                                disabled={!inputValues[user.id]?.trim()}
                                                            >
                                                                <i className="bi bi-send-fill"></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default Chat;